import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';
import Home from './pages/Home';
import Navbar from './pages/components/Navbar';

import BubbleButton from './pages/components/BubbleButton';
import About from './pages/About';
import Contact from './pages/Contact';
import UniqueFeatures from './pages/UniqueFeatures';
import Cbse from './pages/Cbse';
import Icse from './pages/Icse';
import Ntse from './pages/Ntse';
import OnlineExam from './pages/OnlineExam';
import Elibrary from './pages/Elibrary';
import PSC from './pages/PSC';
import FloatingMenu from './pages/components/FloatingMenu';
import Forum from './pages/Forum';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import FloatingSocialMenu from './pages/components/FloatingSocialMenu';
import FAQ from './pages/FAQ';
import Founders from './pages/Founders';
import ScrollToTopButton from './pages/components/ScrollToTopButton';
import Associates from './pages/Associates';

const Loader = () => (
  <div style={{
    height: '100vh',
    width: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    position: 'fixed',
    top: 0,
    left: 0
  }}>
    <FaSpinner style={{
      fontSize: '3rem',
      color: '#275E76',
      animation: 'spin 1s linear infinite'
    }} />
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

function AppContent() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const hiddenPaths = [
    '/thankyou',
    '/login',
    '/register',
    '/admin-dashboard',
    '/user-dashboard',
    '/create-board',
    '/create-class',
    '/create-subject',
    '/create-chapter-type',
    '/create-chapter',
    '/create-question-type',
    '/upload-questions',
    '/question-bank',
    '/create-exam-type',
    '/create-exam',
    '/exam-screen',
    '/diagonstic-test-screen',
    '/chapter-test-examscreen',
    '/kiranavali-dashboard'
  ];

  const hideUI = hiddenPaths.some(path =>
    location.pathname.startsWith(path)
  );

  useEffect(() => {
    setIsLoading(true);

    const handleLoad = () => setIsLoading(false);

    if (document.readyState === 'complete') {
      setTimeout(handleLoad, 300);
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, [location.pathname]);

  const handleBubbleClick = () => {
    window.open("/", "_blank");
  };

  return (
    <>
      {isLoading && <Loader />}
      {!isLoading && (
        <>
          {/* {!hideUI && <Navbar />} */}
          {/* {!hideUI && <BubbleButton label="Forum" onClick={handleBubbleClick} />} */}
          {/* {!hideUI && <BubbleButton label="KIRNAVALI"  />} */}

          {!hideUI && <FloatingMenu /> }
          {!hideUI && <FloatingSocialMenu /> }
          {!hideUI && <ScrollToTopButton /> }

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/unique-features" element={<UniqueFeatures />} />
            <Route path="/courses-cbse" element={<Cbse />} />
            <Route path="/courses-icse" element={<Icse />} />
            <Route path="/courses-ntse" element={<Ntse />} />
            <Route path="/online-exam" element={<OnlineExam />} />
            <Route path="/e-library" element={<Elibrary />} />
            <Route path="/performance-scorecard" element={<PSC />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/founders" element={<Founders />} />
            <Route path="/associates" element={<Associates />} />
          </Routes>

          {/* {!hideUI && <Footer />} */}
        </>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
